const isProduction = process.env.NODE_ENV === 'production';

// Hidden in production by default while the feature is in progress.
// Set REACT_APP_ENABLE_TODAYS_FRIENDSHIP_ACTION=true to enable it in prod.
export const isTodaysFriendshipActionEnabled =
  process.env.REACT_APP_ENABLE_TODAYS_FRIENDSHIP_ACTION === 'true' || !isProduction;
